import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { EAP_APP, GM_APP, IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { UserService } from 'src/app/services/user.service';
import { SetupReviewModelComponent } from '../schedule-review/setup-review-model/setup-review-model.component';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { ReferencesComponent } from './references/references.component';
import { DocumentreviewComponent } from './documentreview/documentreview.component';
import { CompleteReviewComponent } from './complete-review/complete-review.component';
import * as $ from 'jquery';
import { IstDataShareService } from 'src/app/services/ist/ist-datashare.service';
import { HeadService } from 'src/app/services/common/headservice';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { serviceConstants } from 'src/app/constants/service.constants';

@Component({
  selector: 'app-my-reviews',
  templateUrl: './my-reviews.component.html',
  styleUrls: ['./my-reviews.component.scss']
})
export class MyReviewsComponent implements OnInit {
  istapp: IST_APP;
  eapapp: EAP_APP;
  grantsapp: GM_APP;
  ApplicationCode: any;
  ApplicationStatus: any;
  module: any;
  ApplicationID: any; 
  SubModule: any;
  Reviews: any[]=[];
  gridApi: GridApi;
  selectedRow;
  tempoperations;
  columnDefs;
  operations;
  rowData;
  IST_Display_Name:String
  Grants_Display_Name:String
  moduleId: string;
  open: any;
  closed: any;
  cancel: any;
  orgDetails;
  ist: boolean;
  eap: boolean;
  grants: boolean;
  isOwner : boolean = true;
  user: any;
  currentTab="";
  currentModule="";
  currentOwner="";

  constructor(  
    public modalRef: NgbActiveModal,
    private reviewService: ReviewService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private userService: UserService,
    private router: Router,
    private dataShare:IstDataShareService,
    private header: HeadService,
    private summaryService:IstSummaryService
  ) {
   
  }

  ngOnInit() {   
    this.orgDetails = this.commonService.getOrgDetails();
    this.IST_Display_Name = this.orgDetails[0].IST_DISPLAY_NAME; 
    this.Grants_Display_Name = this.orgDetails[0].GRANTS_DISPLAY_NAME;
    this.ist = this.orgDetails[0].IST;
    this.eap = this.orgDetails[0].EAP;
    this.grants = this.orgDetails[0].GRANTS;   
    
    this.user = this.userService.getUserDetais();
    if(this.ist){
      this.currentModule="IST";
      this.currentOwner = "Owner";
      this.currentTab = "Open";
      this.GetMyReviews(this.currentModule,this.currentOwner, this.currentTab);
    } else if(this.grants){
      this.currentModule="GRANTS";
      this.currentOwner = "Owner";
      this.currentTab = "Open";
      this.GetMyReviews(this.currentModule,this.currentOwner, this.currentTab);
    }

    this.tempoperations = [ ];

    //this.GetApplicationDetails();
    
  }

  
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
   
      // let modalRef1 = this['self'].modalService.open(FundRequestModalComponent, {
      //   backdrop: false,
      //   keyboard: false,
      //   windowClass: 'modal-vlg right modal-right',
      //   animation: true
      // });
      // modalRef1.componentInstance.Content= {
      //   heading: 'View',
      //   content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
      // }
      //modalRef1.content.action.subscribe(result => {
      //  this['self'].getSummary();
      //})
    

  }

  GetApplicationDetails(){
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {   
        this.ApplicationID = this.commonService.appId;//params['id'];
        this.SubModule = params['submodule'];
      }
    });
  }

  // Grid Data
  ModuleChange(moduleid)
  {
    this.currentModule=moduleid;
     this.currentTab='Open';
     this.currentOwner='Owner';
    this.GetMyReviews(this.currentModule,this.currentOwner,this.currentTab);
  }
  OwnerChange(OwnerID)
  {
    this.currentOwner=OwnerID;
    this.currentTab='Open';
    this.GetMyReviews(this.currentModule,this.currentOwner,this.currentTab);
  }
  TabChangeChange(tab)
  {
    this.currentTab=tab;
    this.GetMyReviews(this.currentModule,this.currentOwner,this.currentTab);
  }

  GetReviewsCount(Owner: string = "Owner", Module) {
   // let isOwner : boolean = true;
    if(Owner == "Owner"){
      this.isOwner = true;
    } else{
      this.isOwner = false;
    }

    if(Module == 'IST' && this.ist){
      this.moduleId = "2";
    }

    if(Module == 'GRANTS' && this.grants){
      this.moduleId = "4";
    }

    this.reviewService.GetReviewsCount("api/Review/MyReviewsCount?isOwner=" + this.isOwner + "&Module=" + this.moduleId).subscribe((result: any[] )=> {
      if (result) {
       this.open = result["OpenCount"];
       this.closed = result["ClosedCount"];
       this.cancel = result["CancelledCount"];
      }
    });
  }

  GetMyReviews(Module, Owner,Status) {
    if(Owner == "Owner"){
      this.isOwner = true;
    } else{
      this.isOwner = false;
    }    
    let formData = 
    { 
      "Status": Status ,
      "GrantType":this.SubModule,
      "Module": Module,
      "isOwner": this.isOwner
    };

    if(Module == 'IST' && this.isOwner){
      this.columnDefs = [
        {
          "headerName": "Review Title",
          "field": "Title"
        },
        {
          "headerName": "Application ID",
          "field": "Application_Code"
        }       
      ];

      if(Module == 'GRANTS'){
        this.columnDefs.push({
          "headerName": "GrantType",
          "field": "GrantType"
        });
      } 

      this.columnDefs.push( {
        "headerName": "Planned End Date",
        "field": "StrPlannedEndDate"            
      },     
      {
        "headerName": "Review Status",
        "field": "strReviewStatus"
      });
    } else{
      this.columnDefs = [
        {
          "headerName": "Review Title",
          "field": "Title"
        },
        {
          "headerName": "Application ID",
          "field": "Application_Code"
        }        
      ];

      if(Module == 'GRANTS'){
        this.columnDefs.push({
          "headerName": "GrantType",
          "field": "GrantType"
        });
      } 

      this.columnDefs.push( {
        "headerName": "Planned End Date",
        "field": "StrPlannedEndDate"            
      },
      {
        "headerName": "Review Status",
        "field": "strReviewStatus"
      });

      if(!this.isOwner){
        this.columnDefs.push( {
          "headerName": "My Status",
          "field": "strMyStatus"
        })
      }
    }

    this.columnDefs.push({
      headerName: "Review Details",
            field: "value",
            cellRenderer: "editAndDeleteOperationsRenderer",
            colId: "params",
            width: 180,
            sortable: false,
            IsRequiredFile:true,
            CalBackFunctionName:{
              name: "Reference",
              callback: this["Reference"],
              self: this,
              disabled: "false"
            },
            cellStyle: { "overflow": 'visible' }
    })
  

    this.reviewService.GetMyReviews("api/Review/MyReviews", formData).subscribe((result: any[] )=> {
      if (result) {
        this.rowData = this.setOperations(result, Owner);    
        this.GetReviewsCount(Owner, Module);  
        this.gridApi.sizeColumnsToFit();
      }
    });
  }

  setOperations(RawData: any, Owner: string = 'Owner'): any {

    this.setDef(this.tempoperations);
    RawData.forEach(element => {  

      if (Owner == 'Owner') {
        if (element.strReviewStatus == "Closed" || element.strReviewStatus == "Cancelled" || element.strReviewStatus == "Deleted") {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "ViewReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);

        }

        if (element.strReviewStatus == "Pending") {
          let tempoperations2 = [
            {
              "name": "Change Owner",
              "id": "Changeowner_Review"
            },
            {
              "name": "Start Review",
              "id": "StartReview"
            },
            {
              "name": "Edit",              
              "id": "EditReview"
            },
            {
              "name": "Delete",
              "id": "DeleteReviewConf"
            },
            {
              "name": "View",
              "id": "ViewReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);

        }

        if (element.strReviewStatus == "InProgress") {
          let tempoperations2 = [
            {
              "name": "Change Owner",
              "id": "Changeowner_Review"
            },
            {
              "name": "Edit",
              "id": "EditReview"
            },
            {
              "name": "Cancel",
              "id": "CancelReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);

        }

        if (element.strReviewStatus == "Completed") {
          let tempoperations2 = [
            {
              "name": "Change Owner",
              "id": "Changeowner_Review"
            },
            {
              "name": "Close",
              "id": "CloseReview"
            },
            {
              "name": "View",
              "id": "ViewReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);

        }
      } else{
        if(element.strMyStatus == "Planned" && element.HasReviewPrevilage){
          let tempoperations2 = [
            {
              "name": "View Application",
              "id": "ViewContriReview"
            },
            {
              "name": "Start Review",
              "id": "startReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        } 

        if(element.strMyStatus == "InProgress" && element.HasReviewPrevilage){
          let tempoperations2 = [
            {
              "name": "View Application",
              "id": "ViewContriReview"
            },
            {
              "name": "Update Review",
              "id": "updateReview"
            },
            {
              "name": "Complete Review",
              "id": "completReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }

        if(element.strMyStatus == "Aborted" || element.strReviewStatus == "Cancelled" || element.strReviewStatus == "Closed" || !element.HasReviewPrevilage){
          let tempoperations2 = [
            {
              "name": "View Application",
              "id": "ViewContriReview"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }    
    });
    return RawData;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  close(){
    this.modalRef.close();
  }

  // Grid Actions

  ViewContriReview(){
     let url= this['self'].router.createUrlTree(['/applicationview/'+this['self'].selectedRow["Application_ID"]+"/"+this['self'].selectedRow["ModuleID"]]);
     window.open(url,"_blanck");
  } 

  startReview() {
    let ReviewDocs = this['self'].selectedRow["ReviewDocs"];
    let module = this['self'].selectedRow["ModuleID"];
    let updateDocs = ReviewDocs.find(y => y.Status === "Start");
    if (ReviewDocs.length === 1) {
      let formData = { "ReviewId":this['self'].selectedRow["ID"],"ReviewDocId": this['self'].selectedRow["DocID"], "ApplicationCode": this['self'].selectedRow["Application_Code"], DocStatus: updateDocs.Status};   
      this['self'].reviewService.UpdateDocReviewerStatus("api/Review/UpdateDocReviewerStatus", formData).subscribe((result)=> {
        this['self'].commonService.OnlyOfficePopupLanch(updateDocs.FileID, this['self'].selectedRow["ID"], this['self'].selectedRow["ReviewDocs"],  this['self'].selectedRow["Application_Code"]).subscribe(x=>{
          this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
        });
      });  

    } else {
      let modalRef = this['self'].modalService.open(DocumentreviewComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg modal-dialog-center',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Start',
        content: { ReviewId: this['self'].selectedRow["ID"], applicationId: this['self'].selectedRow["Application_ID"], 
                    reviewDocs: ReviewDocs, applicationCode: this['self'].selectedRow["Application_Code"], module: this['self'].selectedRow["ModuleID"] }
      }
      modalRef.result.then(result => {  
        this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);  
      });
    }
  }

  updateReview(){
    let ReviewDocs = this['self'].selectedRow["ReviewDocs"];
    let updateDocs = ReviewDocs.filter(y=> y.Status == "Update" || y.Status == "Start");
    let modalRef = this['self'].modalService.open(DocumentreviewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Update',
      content: { ReviewId: this['self'].selectedRow["ID"], applicationId: this['self'].selectedRow["Application_ID"],
       reviewDocs: updateDocs, applicationCode: this['self'].selectedRow["Application_Code"] , module: this['self'].selectedRow["ModuleID"]}
    }
    modalRef.result.then(result => {
      this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
    });
  }

  completReview() {
    let module = this['self'].selectedRow["ModuleID"];
    let ReviewDocs = this['self'].selectedRow["ReviewDocs"];
    let updateDocs = ReviewDocs.filter(y => y.Status === "Update");
    if (ReviewDocs.length === 1) {
      let modalRefe = this['self'].modalService.open(DeleteBoxComponent, { backdrop: false });
      modalRefe.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for ' + updateDocs[0].FileName + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" };
      modalRefe.result.then(result => {
        if (result == "okclick") {
          let formData = { "ReviewId": this['self'].selectedRow["ID"], "ReviewDocId": updateDocs[0].FileID, "ApplicationCode": this['self'].selectedRow["Application_Code"], DocStatus: updateDocs[0].Status };
          this['self'].reviewService.UpdateDocReviewerStatus("api/Review/UpdateDocReviewerStatus", formData).subscribe((result: any) => {
            if (result.Status == 0) {
              // this['self'].commonService.SuccessBanner('Review completed successfully');
              this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
            }
          });
        }
      });
    } else {
      let completeDocs = ReviewDocs.filter(z => z.Status == "Update" && z.Status != "Complete");
      let modalRef = this['self'].modalService.open(DocumentreviewComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg modal-dialog-center',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: "Complete",
        content: { ReviewId: this['self'].selectedRow["ID"], reviewDocs: completeDocs, applicationCode: this['self'].selectedRow["Application_Code"], module: this['self'].selectedRow["ModuleID"] }
      }
      modalRef.result.then(result => {
        this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
      });
    }
  }

  completeReview() {
    let ReviewDocs = this['self'].selectedRow["ReviewDocs"];    
    let updateDocs = ReviewDocs.filter(y=> y.Status == "Update");
    if (updateDocs.length == 1) {
      let modalRefe = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
      modalRefe.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for ' + updateDocs[0].FileName + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" };
      modalRefe.result.then(result => {
        if (result == "okclick") {
          let formData = { "ReviewId":this['self'].selectedRow["ID"] ,"ReviewDocId": updateDocs[0].FileID, "ApplicationCode": this['self'].selectedRow["Application_Code"], DocStatus: updateDocs[0].Status };
          this['self'].reviewService.UpdateDocReviewerStatus("api/Review/UpdateDocReviewerStatus", formData).subscribe((result)=> {
            if (result.Status == 0) {
              this.commonService.SuccessBanner('Review completed successfully');
              //this.GetMyReviews();
            }
          });
        }
      });
    } else {
      let completeDocs = ReviewDocs.filter(z=> z.Status == "Update" &&  z.Status != "Complete");
      let modalRef = this['self'].modalService.open(DocumentreviewComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg modal-dialog-center',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Complete',
        content: { ReviewId: this['self'].selectedRow["ID"], applicationId: this['self'].selectedRow["Application_ID"], reviewDocs: completeDocs, applicationCode: this['self'].selectedRow["Application_Code"] }
      }
      modalRef.result.then(result => {

      });
    }
  }

  //Begin owner grid actions

  
  EditReview(){
    let module = this['self'].selectedRow["ModuleID"];
    let modalRef = this['self'].modalService.open(SetupReviewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: { ReviewId:this['self'].selectedRow["ID"], applicationId: this['self'].selectedRow["Application_ID"],
       applicationCode: this['self'].selectedRow["Application_Code"], module: this['self'].selectedRow["ModuleID"], type: "MyReviews" }
    }
    modalRef.result.then(result => {  
      this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
    });
  } 
  
  ViewReview(){   
    let modalRef = this['self'].modalService.open(SetupReviewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'View',
      content: { ReviewId:this['self'].selectedRow["ID"], applicationId: this['self'].selectedRow["Application_ID"], applicationCode: this['self'].selectedRow["Application_Code"] }
    }
    modalRef.result.then(result => {    
      this['self'].GetMyReviews();
    });
  } 

  Changeowner_Review(){
    let module = this['self'].selectedRow["ModuleID"];
    let modalRef = this['self'].modalService.open(SetupReviewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: { ReviewId:this['self'].selectedRow["ID"],IsChangeOwner:true, applicationId: this['self'].selectedRow["Application_ID"], applicationCode: this['self'].selectedRow["Application_Code"]  }
    }
    modalRef.result.then(result => {    
      this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
    });
  } 

  StartReview(){
    let module = this['self'].selectedRow["ModuleID"];
    // let formData = { "ID":this['self'].selectedRow["ID"] ,"MODULE_ID":this.moduleId ,"Application_Code":this.appCode
    // ,"GrantType":this.SubModule };
    this['self'].reviewService.StartReview("api/Review/CheckReviwerBeforeStart?AppId=" + this['self'].selectedRow["Application_ID"] + "&RevSeqNo=" + this['self'].selectedRow["SeqNo"] ).subscribe(res => {
      if (res.Status == 0) {   
       this['self'].reviewService.StartReview("api/Review/StartReview?Id=" + this['self'].selectedRow["ID"] + "&AppCode=" + this['self'].selectedRow["Application_Code"] ).subscribe(result => {
      if (result.Status == 0) {       
        this['self'].commonService.SuccessBanner(result.Message);
        this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
        
      }
      else{
        this['self'].commonService.ValidationBanner(result.Message);
      }    
    });
  }
  else{
    this['self'].commonService.ValidationBanner(res.Message);
  }    
});
  }

   

  DeleteReviewConf(Review:any) {    
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false
  })   
  modalRef.componentInstance.Content={ heading: 'Confirmation', custommessage: 'Do you really want to delete the selected review?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
    modalRef.result.then((result) => {
      if(result=="okclick")
      {        
        this['self'].DeleteReview(this['self'].selectedRow["ID"], this['self'].selectedRow["Application_Code"], this['self'].selectedRow["ModuleID"]); 
        this['self'].modalRef.close();    
      }
    });
  }

  DeleteReview = (Id:any,AppCode:any, module: string) => {
    
    // let formData = { "ID":Review.ID ,"MODULE_ID":this.moduleId ,"Application_Code":this.appCode
    // ,"GrantType":this.SubModule };
    this.reviewService.DeleteReview("api/Review/DeleteReview?Id=" + Id + "&AppCode=" + AppCode).subscribe(result => {
      if (result.Status == 0) {    
        this.commonService.SuccessBanner(result.Message);
        this.GetMyReviews(this.currentModule,this.currentOwner,this.currentTab);
        this.modalRef.close()
        } else {        
          this.commonService.ValidationBanner(result.Message);      
      }
    });
  }

  CancelReview(){
    let module = this['self'].selectedRow["ModuleID"];
    // let formData = { "ID":Review.ID ,"MODULE_ID":this.moduleId ,"Application_Code":this.appCode
    // ,"GrantType":this.SubModule, "Application_ID": this.ApplicationID };
    this['self'].reviewService.CancelReview("api/Review/CancelReview?Id=" + this['self'].selectedRow["ID"] + "&AppCode=" + this['self'].selectedRow["Application_Code"] ).subscribe(result => {
      if (result.Status == 0) {       
        this['self'].commonService.SuccessBanner(result.Message);
        this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
      }
      else{
        this['self'].commonService.ValidationBanner(result.Message);
      }    
    });
  }

  CloseReview(){
    let module = this['self'].selectedRow["ModuleID"];
    let modalRef = this['self'].modalService.open(CompleteReviewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Task Completion',
      content: { ReviewId:this['self'].selectedRow["ID"],applicationCode: this['self'].selectedRow["Application_Code"]}
    }
    modalRef.result.then(result => {  
      this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
    });
    
  }

  //End owner grid actions  

  Reference()
  {
    let module = this['self'].selectedRow["ModuleID"];
    let poputype =this['self'].isOwner==true? "Owner":"Contributor"
    let modalRef = this['self'].modalService.open(ReferencesComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Reference',
      content: { ReviewId:this['self'].selectedRow["ID"],  applicationCode: this['self'].selectedRow["Application_Code"] ,PopupType: poputype,
                ReviewStatus: this['self'].selectedRow["ReviewStatus"] }
    }
    modalRef.result.then(result => {    
      this['self'].GetMyReviews(this['self'].currentModule,this['self'].currentOwner,this['self'].currentTab);
    });
  }

}
